<template>
  <div style="display: none"></div>
</template>
<script>
import { getLodop } from "@/plugins/data/LodopFuncs";
import {
  PRINT_SCENES,
  resolvePrintTemplate,
  resolvePrintTemplateWithOverride,
  truncateText,
  formatChannelLabel,
} from "@/unit/printTemplateStorage.js";
import { renderStoreTopicNative } from "@/unit/printLodopNative.js";

export default {
  props: {
    stageDate: {
      type: Object,
      default: () => ({}),
    },
    factoryName: {
      type: String,
      default: "",
    },
    isTextQ: {
      type: Boolean,
      default: false,
    },
    grillObj: {
      type: Object,
      default: () => ({}),
    },
    templateOverride: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      printName: this.factoryName,
      item: this.stageDate,
      isText: this.isTextQ,
      grillObjs: this.grillObj,
    };
  },
  watch: {
    stageDate(newVal) {
      this.item = newVal;
    },
    factoryName(newVal) {
      this.printName = newVal;
    },
    isTextQ(newVal) {
      this.isText = newVal;
    },
    grillObj(newVal) {
      this.grillObjs = newVal;
    },
  },
  mounted() {
    this.$emit("child-event", this.stageDate);
  },
  methods: {
    getTemplate() {
      if (this.templateOverride) {
        return resolvePrintTemplateWithOverride(
          PRINT_SCENES.STORE_TOPIC,
          this.templateOverride,
        );
      }
      return resolvePrintTemplate(PRINT_SCENES.STORE_TOPIC);
    },
    runTopicLodop(item, preview) {
      if (!item || !item.washingCode) {
        return false;
      }
      const LODOP = getLodop();
      if (!LODOP) {
        return false;
      }
      const printName = this.printName != null ? this.printName : -1;
      const tpl = this.getTemplate();
      LODOP.PRINT_INIT("总检码" + item.washingCode);
      renderStoreTopicNative(
        LODOP,
        tpl,
        item,
        printName,
        this.grillObjs,
        this.isText,
      );
      if (preview) {
        LODOP.PREVIEW();
      } else {
        LODOP.PRINT();
        this.$emit("refreshOffline", true);
      }
      return true;
    },
    print(stageData, grillObj, isTextQ) {
      if (stageData) {
        this.item = stageData;
      }
      if (grillObj) {
        this.grillObjs = grillObj;
      }
      if (isTextQ !== undefined) {
        this.isText = isTextQ;
      }
      return this.runTopicLodop(stageData || this.item, false);
    },
    preview(stageData, grillObj, isTextQ) {
      if (stageData) {
        this.item = stageData;
      }
      if (grillObj) {
        this.grillObjs = grillObj;
      }
      if (isTextQ !== undefined) {
        this.isText = isTextQ;
      }
      return this.runTopicLodop(stageData || this.item, true);
    },
  },
};
</script>
